import React from 'react';
import BaseDrawingMaterialChooser from 'components/quote_builder_widget/shared/BaseDrawingMaterialChooser';
import styles from './_style.module.scss';

const DrawingMaterialChooser = ({ widgetIdentifier, drawingId, onMaterialChange }) => {
  return (
    <BaseDrawingMaterialChooser
      widgetIdentifier={widgetIdentifier}
      drawingId={drawingId}
      onMaterialChange={onMaterialChange}
      styles={styles}
      selectClassName={styles.input}
    />
  );
};

export default DrawingMaterialChooser;
